module.exports = __webpack_public_path__ + "static/Tzatziki-7786148f64bc4cf53981f08cab89c56a.png";